import React, { useContext } from 'react';
import { TextButton } from '@prisjakt/ui/button/variants';
import { BodySmallText, FontWeight } from '@prisjakt/ui/text/variants';
import { ActiveFilterIndicator } from './active-filter-indicator';
import { useHistory } from 'react-router';
import { ActiveFilterRow } from './styles';
import { AppContext } from '@prisjakt/ui-app-context';
import { getFilterFromLocation } from 'src/areas/product/components/product-filters/utils';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { defaultHiddenListOptions } from '../../utils';
import { getActiveFilters } from '../../utils/filters-config';
import RouteContext from 'src/routes/context';
import { MediumUp, MobileOnly } from 'src/ui/block';

export const ActiveFilters: React.FC = () => {
  const { t, market } = useContext(AppContext);

  const history = useHistory();
  const location = history.location;
  const queryFilters = getFilterFromLocation(location);
  const {
    selectedFilters,
    changeMultipleFilterSelection,
    changeSingleFilterSelection,
  } = useContext(PriceListFilterContext);
  const activeFilters = getActiveFilters(
    t,
    selectedFilters,
    defaultHiddenListOptions(market)
  ).filter(f => f.quickFilter === false);
  const { dispatch: routeDispatch } = useContext(RouteContext);

  const queryFilterOnClickHandler = () => {
    if (queryFilters) {
      const queryParams = new URLSearchParams(location.search);
      queryParams.delete('filters');
      history.push(`${location.pathname}?${queryParams.toString()}`);
    }
  };

  const filterOnClickHandler = (name: string, val: boolean) => {
    changeSingleFilterSelection(name, val, routeDispatch);
  };

  const clearFilters = () => {
    const updatedFilters = { ...selectedFilters };
    activeFilters?.forEach(filter => {
      if (!filter.quickFilter) {
        updatedFilters[filter.name] = false;
      }
    });
    changeMultipleFilterSelection(updatedFilters, routeDispatch);
    queryFilterOnClickHandler();
  };

  const queryFiltersExist = queryFilters?.length > 0;
  const activeFiltersExist = activeFilters?.length > 0 || queryFiltersExist;

  return activeFiltersExist ? (
    <>
      <MediumUp>
        <ActiveFilterRow>
          <div>
            <BodySmallText weight={FontWeight.HEAVIER}>
              {t('filter', 'applied-filters.title')}:
            </BodySmallText>
          </div>

          {activeFilters?.map(f => (
            <ActiveFilterIndicator
              key={f.name}
              onClickHandler={() => filterOnClickHandler(f.name, false)}
              text={f.label}
            />
          ))}
          {queryFiltersExist && (
            <ActiveFilterIndicator
              onClickHandler={queryFilterOnClickHandler}
              text={t('store', 'brand.recommended-retailer')}
            />
          )}
          <TextButton onClick={clearFilters}>
            {t('filter', 'button.clear-filter')}
          </TextButton>
        </ActiveFilterRow>
      </MediumUp>

      {queryFiltersExist && (
        <MobileOnly>
          <ActiveFilterRow>
            <div>
              <BodySmallText weight={FontWeight.HEAVIER}>
                {t('filter', 'applied-filters.title')}:
              </BodySmallText>
            </div>
            <ActiveFilterIndicator
              onClickHandler={queryFilterOnClickHandler}
              text={t('store', 'brand.recommended-retailer')}
            />
            <TextButton onClick={queryFilterOnClickHandler}>
              {t('filter', 'button.clear-filter')}
            </TextButton>
          </ActiveFilterRow>
        </MobileOnly>
      )}
    </>
  ) : null;
};
